import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 9c0 5.666 5.351 7.765 11 7.981V23c4.078-3.398 13-7.948 13-14 0-6-6-8-12-8S0 3 0 9m7 .9h10V8.1H7z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BubbleRoundFilledSize24Glyph.displayName = 'BubbleRoundFilledSize24Glyph';
